<script>
export let tagModal="";
export let abrirModal=false;
export let tituloModal=false;
export let mensagemModal=false;
export let textoBotaoNegativo="";
export let textoBotaoNeutro="";
export let textoBotaoPositivo="";
export let retornoBotaoNegativo="";
export let retornoBotaoNeutro="";
export let retornoBotaoPositivo="";



export let passagemModal={
         abrirModal:true,
         titulo:"",
         mensagem:"",
         botaoNegativo:null,
         botaoPositivo:null,
         botaoNeutro:null



};
let open=true;
import {createEventDispatcher } from 'svelte';
import {onMount} from "svelte";
const dispatch = createEventDispatcher();



import {Button,  
  ButtonGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader} from "sveltestrap";




function CliqueNegativo(){
    console.log("clique negativo;")
    dispatch("CliqueNegativo");
    passagemModal.abrirModal=false;
   
}
function CliqueNeutro(){
    console.log("clique neutro;")
    dispatch("CliqueNeutro");
    passagemModal.abrirModal=false;
    
}
function CliquePositivo(){
    console.log("clique positivo;")
    dispatch("CliquePositivo");
    passagemModal.abrirModal=false;
    
}
</script>

<Modal isOpen={passagemModal.abrirModal} class="modal-body">
                            <ModalHeader {open}>{passagemModal.titulo}</ModalHeader>
                                <ModalBody>
                                {@html passagemModal.mensagem}
                                
                                </ModalBody>
                                <ModalFooter>
                                {#if passagemModal.botaoNegativo!=null}
                                <Button color="danger" on:click={(e)=>CliqueNegativo(e)}>
                                    {passagemModal.botaoNegativo}
                                </Button>
                                {/if}
                                {#if passagemModal.botaoNeutro!=null}
                                <Button color="secondary" on:click={(e)=>CliqueNeutro(e)}>
                                   {passagemModal.botaoNeutro}  
                                </Button> 
                                 {/if}
                                {#if passagemModal.botaoPositivo!=null}
                                <Button color="primary" on:click={(e)=>CliquePositivo(e)}>
                                   {passagemModal.botaoPositivo}  
                                </Button> 
                                {/if}
                                </ModalFooter>           </Modal> 

